module.exports = __webpack_public_path__ + "static/media/play.30f38e6c.png";